import React from "react";
import './Button.css'

const Button = (props) => {
    return (
        <button>Visit {props.github!==0 ? <i className="fa-brands fa-github"></i> : <i class="fa-brands fa-chrome"></i>}</button>
    )
};

export default Button;